const SCREEN_NAMES = {
  FORGOT_PASSWORD: 'forgot-password',
  HEADER: 'header',
  PROJECTS: 'projects',
  PACKAGES: 'packages',
  TALENT: 'talent',
  WORKSHEET: 'worksheet',
  FILTER: 'filter',
  ROSTER: 'roster',
  INVITATION_HISTORY: 'invitation-history',
  INVITATION_TALENT: 'invite-talent',
  CREATE_PROFILE: 'create-profile',
  MEDIA_BANK: 'media-bank',
};

export default SCREEN_NAMES;
